
interface IToogleButtonProps {
  textColor?: string;
  className?: string;
  buttonText: {
    label: string;
    value: string;
  }[];
  checkedValue: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}
export default function ToogleButton({
  textColor = 'text-reliableBlack80',
  className = '', 
  buttonText,
  checkedValue,
  handleChange = () => {},
}: IToogleButtonProps) {
  return (
    <div className={`${className} container pb-6`}>
      <div className={`md:w-[448px] grid grid-cols-2 gap-2 rounded-[8px] bg-[#F4F4F4] p-1`}>
        {buttonText.map((item) => {
          return (
            <div key={item.value}>
              <input
                type="radio"
                name={`option ${item.value}`}
                id={item.value}
                value={item.value}
                className="peer hidden "
                onChange={handleChange}
                checked={checkedValue === item.value}
              />
              <label
                htmlFor={item.value}
                className={`block text-[14px] uppercase cursor-pointer select-none rounded-[4px] p-2 text-center peer-checked:bg-reliableBlack peer-checked:text-600 peer-checked:text-white ${textColor}`}
              >
                {item.label}
              </label>
            </div>
          );
        })}
      </div>
    </div>
  );
}
